import { Component, EventEmitter, Input, Output, WritableSignal, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { FormField } from 'src/app/shared/forms/abstract-form-field.directive';
import { FormContainerVM, FormFieldValue, FormVMContainerDirective } from 'src/app/shared/forms/form-vm-container.directive';
import { invertedStringToDate, isSameDay } from 'src/app/shared/utils/dates';
import { Format } from 'src/app/shared/utils/format';
import { getDate } from 'src/app/shared/utils/typeconversions';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent extends FormField<Date | null> {

  readonly type = 'date'

  date: Date | null = null
  @Input()
  set  value(v : Date |  string | null) {
    const date = getDate(v);
    this.model = date.extractNullable()
  }
  get value() {
    return this.model ?? null;
  }

  // @Input() control: FormControl = new FormControl();

  _any? : any

  _max: string | null = null
  _min: string | null = null

  // overformVMContainer: FormVMContainerDirective | null = null;

  @Input() set max(value: Date | null | undefined | 'today') {
    if (value == null || value == undefined) {
      this._max = null;
    } else if (value == 'today') {
      this._max = Format.dateToInvertedStringFormat(new Date())
    } else {
      this._max = Format.dateToInvertedStringFormat(value)
    }
  }
  @Input() set min(value: Date | null | undefined | 'today') {
    if (value == null || value == undefined) {
      this._min = null;
    } else if (value == 'today') {
      this._min = Format.dateToInvertedStringFormat(new Date())
    } else {
      this._min = Format.dateToInvertedStringFormat(value)
    }
    // console.log({_min : this._min})
  }


  @Input() singalInput?: WritableSignal<Date | null>;

  @Output() onSelect = new EventEmitter<Date | null>();

  updateInternalCtr(){
    if (this.value === null) {
      this.date = this.value;
      this.control.patchValue(null);
      return
    }
    if (! (this.value instanceof Date) ) {
      this.value = new Date(this.value)
    }
    this.date = this.value
    this.control.patchValue( Format.dateToInvertedStringFormat(this.date!) , {emitEvent: false})

    // this.disabledManualBinding()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.updateInternalCtr()
    }
  }

  log(x?: any) {
    // console.log(x)
  }

  changeDate(dateInvertedString : string) {
    this.model = invertedStringToDate(dateInvertedString)
    this.onSelect.emit(this.model)
  }

  updateModel(formVM: FormContainerVM, value: FormFieldValue): FormContainerVM {
    return {
      ...formVM,
      [this.name] : value
    }
  }

  // onChange(event: EventTarget | null){
  //   this.date = (event as HTMLInputElement)?.valueAsDate;
  //   this.date?.setHours(24);
  //   this.onSelect.emit(this.date);
  //   this.fieldModel.next(this.date)
  // }
}
